import { Button } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { forwardRef } from "react";

const HideableMenuButton = forwardRef(({ isVisible, onClick, children }, ref) => {

  const visibleStyle = {
    display: "inline-flex",
  };

  const hiddenStyle = {
    position: 'absolute',
    top: -9999,
    left: -9999,
  };

  const styles = isVisible ? visibleStyle : hiddenStyle;

  return (
    <Button
      ref={ref}
      sx={styles}
      endIcon={<MoreVertIcon />}
      onClick={onClick}
    >
      {children}
    </Button>
  );
});

export default HideableMenuButton;